/**
 * @generated SignedSource<<1a2c08cdfc0dde943b83311edf4b54a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleListItemScheduleRange_routineOccasion$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItemMonthlyRange_routineOccasion" | "TeamScheduleListItemWeeklyRange_routineOccasion">;
  readonly " $fragmentType": "TeamScheduleListItemScheduleRange_routineOccasion";
};
export type TeamScheduleListItemScheduleRange_routineOccasion$key = {
  readonly " $data"?: TeamScheduleListItemScheduleRange_routineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItemScheduleRange_routineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleListItemScheduleRange_routineOccasion",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleListItemWeeklyRange_routineOccasion"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleListItemMonthlyRange_routineOccasion"
    }
  ],
  "type": "ScheduledOccasion",
  "abstractKey": "__isScheduledOccasion"
};

(node as any).hash = "5e827a8c8fbc8c373bbef73e44506c25";

export default node;
